export enum GoogleAssetsEntities {
  IMAGES = 'images',
  Headlines = 'headlines',
  ShortHeadlines = 'shortHeadlines',
  LongHeadlines = 'longHeadlines',
  Descriptions = 'descriptions'
}
